import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pre-contratos',
  templateUrl: './pre-contratos.component.html',
  styleUrls: ['./pre-contratos.component.scss']
})
export class PreContratosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

} 
